<template>
    <div>
        <div class="tabs is-small">
            <ul>
                <router-link
                    :to="{ name: 'branch-settings-cashback-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Cashback</a>
                </router-link>
                <router-link
                    :to="{ name: 'branch-settings-coupon-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Coupon</a>
                </router-link>
                <router-link
                    :to="{ name: 'branch-settings-deposit-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Deposit</a>
                </router-link>
                <router-link
                    :to="{ name: 'branch-settings-registration-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Registration</a>
                </router-link>
                <router-link
                    :to="{ name: 'branch-settings-welcome-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Welcome</a>
                </router-link>
            </ul>
        </div>

        <router-view />
    </div>
</template>
<script>
export default {
    name: 'branch-settings-bonus-index'
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/bonuses/index.vue